import React from 'react';
import { connect } from 'react-redux';
import { AppState, IPageState } from '../../appredux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { ListItemType, OpisyZjazdow, OpisyZjazdowType } from './KarnetKwotowy';


interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
    open: boolean,
    closeDialog: () => void,
    acceptDialog: () => void,
    platnosc: ListItemType
}

interface DialogState {
    //open: boolean
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {

    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            //open: false
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        //if(this.props.page.openDialogError !== prevProps.page.openDialogError){
        //    this.setState({open: true})
        //}
    }


    render() {
        const classes = this.props.classes;

        let opis = OpisyZjazdow.find(x => x.id === this.props.platnosc.id)

       
        return (
            <>
                <Dialog
                    maxWidth="xs"
                    open={this.props.open}
                    onEscapeKeyDown={this.props.closeDialog}
                    onBackdropClick={this.props.closeDialog}
                    fullWidth
                >
                    <DialogTitle disableTypography >
                        <Typography gutterBottom variant="h6" component="h2" color='primary'
                            className={`${classes.headline}`}><b style={{ }}>{'Co masz za ' + opis?.tytul}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
                            {opis?.orczyk}<b className={classes.primary} >{}</b>
                        </DialogContentText> 
                        <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
                            {opis?.tasma}<b className={classes.primary} >{""}</b>
                        </DialogContentText> 
                        {/* <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
                            {"płatność zrobisz w "}<b className={classes.primary} >{"nowej zakładce"}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {""}
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"Czy na pewno płatność on-line?"}
                        </DialogContentText> */}
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" size="small" className={classes.button}
                            onClick={this.props.closeDialog}>
                            <b>wróć</b>
                        </Button>
                        <Button variant="contained" color="primary" size="small" className={classes.button}
                            onClick={this.props.acceptDialog}>
                            <b>OK</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      paddingLeft: {
        paddingLeft: "20px"
      },
      headline: {
        lineHeight: "20px",
      },
      dialogContentText: {
        color: theme.palette.text.secondary,
        whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px'
      },
      button: {
        textTransform: "none" as "none"
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

